/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_Th6Inputs */

const en_mk_cmp_notion_th6 = /** @type {(inputs: Mk_Cmp_Notion_Th6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of the best in its class.`)
};

const id_mk_cmp_notion_th6 = /** @type {(inputs: Mk_Cmp_Notion_Th6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salah satu yang terbaik di kelasnya.`)
};

/**
* | output |
* | --- |
* | "One of the best in its class." |
*
* @param {Mk_Cmp_Notion_Th6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_th6 = /** @type {((inputs?: Mk_Cmp_Notion_Th6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_Th6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_th6(inputs)
	return en_mk_cmp_notion_th6(inputs)
});